import React, { useState, useEffect } from 'react';

const AboutTab = () => {
    const [data, setData] = useState({});
    const [msg, setMsg] = useState('');

    useEffect(() => {
        fetch('/api/about/content')
            .then(res => res.json())
            .then(d => setData(d));
    }, []);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const res = await fetch('/api/about/content', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (res.ok) setMsg('About Us Content Updated!');
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
            <h3 className="text-lg font-black text-slate-800 uppercase mb-4">Edit About Us Page</h3>
            <form onSubmit={handleSave} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                {/* Header Stats */}
                <div>
                    <label className="text-xs font-bold text-slate-400">Est. Year</label>
                    <input name="est_year" value={data.est_year || ''} onChange={handleChange} className="w-full p-2 border rounded font-bold" />
                </div>
                <div>
                    <label className="text-xs font-bold text-slate-400">City</label>
                    <input name="est_city" value={data.est_city || ''} onChange={handleChange} className="w-full p-2 border rounded font-bold" />
                </div>

                {/* Main Heading */}
                <div className="col-span-2 grid grid-cols-3 gap-2">
                    <div>
                        <label className="text-xs font-bold text-slate-400">Heading 1</label>
                        <input name="main_heading_1" value={data.main_heading_1 || ''} onChange={handleChange} className="w-full p-2 border rounded font-black" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-orange-400">Heading 2 (Orange)</label>
                        <input name="main_heading_2" value={data.main_heading_2 || ''} onChange={handleChange} className="w-full p-2 border rounded font-black text-orange-500" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400">Heading 3</label>
                        <input name="main_heading_3" value={data.main_heading_3 || ''} onChange={handleChange} className="w-full p-2 border rounded font-black" />
                    </div>
                </div>

                <div className="col-span-2">
                    <label className="text-xs font-bold text-slate-400">Sub Text (Intro)</label>
                    <textarea name="sub_text" value={data.sub_text || ''} onChange={handleChange} className="w-full p-2 border rounded h-20" />
                </div>

                {/* Who We Are */}
                <div>
                    <label className="text-xs font-bold text-slate-400">Stats (Years Exp)</label>
                    <input name="stats_years" value={data.stats_years || ''} onChange={handleChange} className="w-full p-2 border rounded font-bold" />
                </div>
                <div className="col-span-2">
                    <label className="text-xs font-bold text-slate-400">Who We Are - Paragraph 1</label>
                    <textarea name="who_we_are_text_1" value={data.who_we_are_text_1 || ''} onChange={handleChange} className="w-full p-2 border rounded h-24" />
                </div>
                 <div className="col-span-2">
                    <label className="text-xs font-bold text-slate-400">Who We Are - Paragraph 2</label>
                    <textarea name="who_we_are_text_2" value={data.who_we_are_text_2 || ''} onChange={handleChange} className="w-full p-2 border rounded h-24" />
                </div>

                {/* Vision Mission */}
                <div className="col-span-2">
                    <label className="text-xs font-bold text-slate-400">Our Vision</label>
                    <textarea name="vision_text" value={data.vision_text || ''} onChange={handleChange} className="w-full p-2 border rounded h-20" />
                </div>
                <div className="col-span-2">
                    <label className="text-xs font-bold text-slate-400">Our Mission</label>
                    <textarea name="mission_text" value={data.mission_text || ''} onChange={handleChange} className="w-full p-2 border rounded h-20" />
                </div>

                <div className="col-span-2 mt-4">
                    <button type="submit" className="bg-slate-900 text-white px-8 py-3 rounded-lg font-bold uppercase w-full hover:bg-orange-500 transition-colors">Save Changes</button>
                    {msg && <p className="text-center text-green-500 font-bold mt-2">{msg}</p>}
                </div>
            </form>
        </div>
    );
};

export default AboutTab;